<template>
    <div class="change-btn-userhistory" :class="{'recap' : isRecap}">

        <router-link v-if="showPrevBtn()" class="left right-bordered" :class="{'is-recap' : isRecap}" @click.native="prevBtnRecapPress"
                     tag="button" :to="{name:'constructor', params : {
                        type : $store.state.productType,
                        step : prevStep().toString()
                      }}">Retour
        </router-link>
        <router-link v-if="showNextBtn() && !preventNextButton" class="right next-button" :class="{'is-recap' : isRecap}" @click.native="nextBtnPress"
                     tag="button" :to="{name:'constructor', params : {
                        type : $store.state.productType,
                        step : nextStep().toString()
                      }}">
            Étape suivante
        </router-link>
        <button v-else-if="!isRecap" class="right disabled test"
                data-tooltip="Merci de répondre à toute les questions de la page pour passer à l'etape suivante."
                data-tooltip-position="top">
            Étape suivante
        </button>
    </div>
</template>

<script>
    import stepDependenciesAreMet from "../lib/stepDependenciesAreMet";
    //let htmlToImage = require("html-to-image");
    //let htmlToJson = require("html-to-json");

    export default {
        name: "ChangeStepUserHistory",
        mixins: [history],

        props: {},
        data() {
            return {
                backTo: this.step - 1,
                userlikeIClasses: "",
            }
        },

        watch: {
            $route(to, from) {
                if (from.path === to.path) {
                    this.backTo--;
                    this.$router.push({
                        name: "constructor", params: {
                            type: this.$store.productType,
                            step: this.backTo,
                        }
                    })
                } else {
                    this.backTo = this.step
                }
            }
        },
        computed: {
            maxNumberOfSteps() {
                return Object.keys(this.$store.state.steps).length
            },
            apiUrl() {
                return this.$store.state.apiUrl
            },
            step() {
                return this.$store.state.currentStep
            },
            answers() {
                return this.$store.state.answers || [];
            },
            steps() {
                return this.$store.state.steps || [];
            },
            validSteps() {
                return this.$store.state.validSteps || [];
            },
            isLastBtn() {
                const step = parseInt(this.step);

                return step + 1 === this.maxNumberOfSteps
            },
            isRecap() {
                return parseInt(this.$route.params.step) === Object.keys(this.$store.state.steps).length
            },
            isPrevLastScreen() {
                const step = parseInt(this.step);

                return step === this.maxNumberOfSteps
            },
            preventNextButton() {
                return this.$store.state.preventNextButton
            },
            isBackCapLocked() {
                return this.$store.state.lockBackCap
            },

        },

        methods: {
            isNextStepHidden() {

                return !stepDependenciesAreMet(this.steps[parseInt(this.step) + 1], this.answers);
            },

            isPrevStepHidden(step) {
                let prevStep;
                if (step === undefined)
                    prevStep = parseInt(this.step) - 1;
                else
                    prevStep = parseInt(step) - 1;


                if (prevStep <= 0) {
                    return false;
                }

                return !stepDependenciesAreMet(this.steps[prevStep], this.answers);
            },

            nextStep() {
                return parseInt(this.step) + (this.isNextStepHidden() ? 2 : 1);
            },

            prevStep() {

                let prevStep = 1;
                for (let i = this.step; i >= 0; i--) {
                    if (!this.isPrevStepHidden(i)) {
                        prevStep = i - 1;
                        break;
                    }
                }
                return prevStep;
            },

            showNextBtn() {
                const step = parseInt(this.step);
                return (step + 1 <= this.maxNumberOfSteps && this.validSteps.indexOf(String(step)) !== -1) || (this.steps[this.step] !== undefined && this.steps[this.step].noRequire !== undefined && this.steps[this.step].noRequire);
            },

            showPrevBtn() {

                return parseInt(this.step) - 1 !== 0 && !this.isBackCapLocked
            },
            nextBtnPress() {
                if (this.isLastBtn) {
                    this.$store.dispatch('calculatePrice')
                }
                window.scrollTo(0,0);
            },
            prevBtnRecapPress() {
                window.scrollTo(0,0);
                if (this.isPrevLastScreen) {
                    this.$store.dispatch('saveProductPreviewNode', null)
                    this.$store.dispatch('calculatePrice', null)
                }
            },
        }
    }
</script>


<style scoped>

    [data-tooltip] {
        position: relative;
    }

    [data-tooltip-position="top"]:after {
        z-index: 50;
        content: '';
        display: none;
        position: absolute;
        width: 0;
        height: 0;
        border: solid transparent;
    }

    [data-tooltip-position="top"]::after {
        bottom: 125%;
        border-width: 6px 6px 0;
        border-top-color: #000;
        left: 50%;
        margin-left: -6px;
        margin-bottom: -6px;
    }

    [data-tooltip]:hover::before,
    [data-tooltip]:hover::after {
        display: block;
    }

    /* Tooltip styling */
    [data-tooltip]::before {
        content: attr(data-tooltip);
        display: none;
        position: absolute;
        background: #000;
        color: #fff;
        padding: 4px 8px;
        font-size: 14px;
        line-height: 1.4;
        min-width: 260px;
        text-align: center;
        border-radius: 4px;
    }

    [data-tooltip-position="top"]::before {
        left: 50%;
        -ms-transform: translateX(-50%);
        -moz-transform: translateX(-50%);
        -webkit-transform: translateX(-50%);
        transform: translateX(-55%);
    }

    [data-tooltip-position="top"]::before {
        bottom: 100%;
        margin-bottom: 10px;
    }

    .disabled {
        background: #c4c4c5 !important;
    }


    .change-btn-userhistory {
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    .change-btn-userhistory.recap {
        justify-content: flex-start;
    }

    .change-btn-userhistory button.is-recap,
    .change-btn-userhistory button.is-recap:focus{
        width: 100%;
    }


    .change-btn-userhistory button,
    .change-btn-userhistory button:focus {
        outline: none;
        width: 50%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        min-height: 65px;
        background: rgb(196, 196, 197);
        color: rgb(0, 0, 0);
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        border-top: white 2px solid;
        border-bottom: white 2px solid;
    }

    .right-bordered {
        border-right: white 2px solid;
    }

    .change-btn-userhistory .left {
        background: #000;
        color: white;
    }

    .recapResponsive .change-btn-userhistory .left {
        width: 100%;
    }


    @media screen and (max-width: 816px) {
        .viewer-open .change-btn {
            width: 100%;
        }

        .details-change-step {
            display: none;
        }
    }

</style>
